import React, { Component } from 'react';
import { connect as reduxConnect } from 'react-redux';
import { isWeb } from './platform';

const ShouldUpdate = (Comp, props) =>
    isWeb
        ? Comp
        : class extends Component {
              static displayName = `FFConnect__${Comp.displayName}`;

              shouldComponentUpdate(nprop) {
                  return nprop.no_render || nprop.jumping ? false : true;
              }
              render() {
                  return this.props.no_render ? null : <Comp {...this.props} />;
              }
          };

export const no_render = { no_render: true };

export const connect = (Comp, props) => reduxConnect(props)(ShouldUpdate(Comp, props));



// WEBPACK FOOTER //
// ./src/components/core/connect.js